module.exports = __webpack_public_path__ + "img/platform-personalized.cf166f5f.svg";